import { DataService } from "@xanadu/service";
import { DataCache } from "./data.cache";
import { Club } from "@xanadu/model";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class ClubCache extends DataCache<Club> {

    constructor(
        dataService: DataService
    ) {
        super(Club, dataService);
    }
}
